var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3C7.55964 3 7 3.55964 7 4.25C7 4.94036 7.55964 5.5 8.25 5.5H15.75C16.4404 5.5 17 4.94036 17 4.25C17 3.55964 16.4404 3 15.75 3H8.25Z",
    fill: "#9756DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8C4.5 7.30964 5.05964 6.75 5.75 6.75H18.25C18.9404 6.75 19.5 7.30964 19.5 8C19.5 8.69036 18.9404 9.25 18.25 9.25H5.75C5.05964 9.25 4.5 8.69036 4.5 8Z",
    fill: "#9756DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13C2 11.6193 3.11929 10.5 4.5 10.5H19.5C20.8807 10.5 22 11.6193 22 13V18C22 19.3807 20.8807 20.5 19.5 20.5H4.5C3.11929 20.5 2 19.3807 2 18V13Z",
    fill: "#9756DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon3);
export default __webpack_public_path__ + "static/media/jobs-icon-3.20d7dfa60b032d0ece8793793cb658f6.svg";
export { ForwardRef as ReactComponent };